import React from "react";
import PropTypes from "prop-types";
import { RTEWrapper } from "BaseComponents/Wrappers";
import { H2 } from "BaseComponents/Text";
export const PublicAnnouncement = ({
	ShowPublicAnnouncement,
	AnnouncementHeading,
	AnnouncementText,
}) => {
	return (
		ShowPublicAnnouncement && (
			<div className="header-wrapper__public-announcement">
				<div className="header-wrapper__public-announcement__content">
					<i className="icon-warning" aria-hidden="true"></i>
					<div>
						{!!AnnouncementHeading.length && <H2>{AnnouncementHeading}</H2>}
						{!!AnnouncementText.length && (
							<RTEWrapper
								className="header-wrapper__public-announcement__content__text"
								dangerouslySetInnerHTML={{
									__html: AnnouncementText,
								}}
							></RTEWrapper>
						)}
					</div>
				</div>
			</div>
		)
	);
};

PublicAnnouncement.propTypes = {
	ShowPublicAnnouncement: PropTypes.bool,
	AnnouncementHeading: PropTypes.string,
	AnnouncementText: PropTypes.string,
};
